var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "controls" }, [
    _vm.moving
      ? _c(
          "div",
          { staticClass: "controls__joystick-position" },
          [_c("Joystick")],
          1
        )
      : _vm.scaling
      ? _c(
          "div",
          { staticClass: "controls__joystick-scale" },
          [_c("Joystick", { attrs: { isScaling: "" } })],
          1
        )
      : _vm.rotating
      ? _c(
          "div",
          { staticClass: "controls__joystick-rotate" },
          [_c("Joystick", { attrs: { isRotation: "" } })],
          1
        )
      : !_vm.downloading && !_vm.pickingColor
      ? _c(
          "div",
          {
            staticClass: "controls__actions",
            style: `transform: scale(${_vm.controlsScale})`,
          },
          [
            _c("div", { staticClass: "controls__buttons-row-wrapper" }, [
              _c(
                "div",
                { staticClass: "controls__undo" },
                [
                  _c("UndoButton", {
                    attrs: { size: "md", disabled: _vm.undoCount === 0 },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.undo.apply(null, arguments)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "controls__buttons-row" },
                [
                  _c("RandomizeButton", {
                    attrs: { size: _vm.buttonSize },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.saveAndRandomize.apply(null, arguments)
                      },
                    },
                  }),
                  _c("ColorPickerButton", {
                    attrs: {
                      size: _vm.buttonSize,
                      color: _vm.color,
                      disabled: !_vm.colorPickerSupported || !_vm.visible,
                    },
                    nativeOn: {
                      mouseup: function ($event) {
                        return _vm.setPickingColor(true)
                      },
                      touchend: function ($event) {
                        return _vm.setPickingColor(true)
                      },
                    },
                  }),
                  _c("RotateButton", {
                    attrs: {
                      size: _vm.buttonSize,
                      disabled: _vm.isBackgroundFeature || !_vm.visible,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.setRotating(true)
                      },
                    },
                  }),
                  _c("ScaleButton", {
                    attrs: {
                      size: _vm.buttonSize,
                      disabled: _vm.isBackgroundFeature || !_vm.visible,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.setScaling(true)
                      },
                    },
                  }),
                  _c("MoveButton", {
                    attrs: {
                      size: _vm.buttonSize,
                      disabled: _vm.isBackgroundFeature || !_vm.visible,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.setMoving(true)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "controls__selectors" }, [
              _c(
                "div",
                {
                  staticClass:
                    "controls__selector-row controls__selector-row--category",
                },
                [
                  _c(
                    "div",
                    { staticClass: "button" },
                    [
                      _c("RectangleButton", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          slanted: "",
                          selector: "",
                          color: "blue",
                          label: _vm.$t(`cat_${_vm.activeCategory}`),
                          func: () => _vm.setCategoryMenuOpen(true),
                          hasIcon: "",
                        },
                      }),
                      _c("EyeButton", {
                        staticClass: "eye",
                        attrs: { px: 31, visible: _vm.visible },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.toggleAsset.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "controls__selector-row controls__selector-row--arrows",
                },
                [
                  _c("ArrowButton", {
                    directives: [
                      {
                        name: "visible",
                        rawName: "v-visible",
                        value: _vm.hasAssets,
                        expression: "hasAssets",
                      },
                    ],
                    staticClass: "arrow",
                    attrs: { size: "xsm", disabled: !_vm.visible },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.prevAsset.apply(null, arguments)
                      },
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "controls__asset-label",
                      class: {
                        "controls__asset-label--disabled": !_vm.visible,
                      },
                      on: { click: _vm.onAssetNameClick },
                    },
                    [
                      _c(
                        "PickedLabel",
                        { attrs: { isLarge: "", notAbsolute: "" } },
                        [
                          _vm._v(" " + _vm._s(_vm.currentAssetName[0])),
                          _c("span", { staticClass: "grey" }, [
                            _vm._v(_vm._s(_vm.currentAssetName[1])),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("ArrowButton", {
                    directives: [
                      {
                        name: "visible",
                        rawName: "v-visible",
                        value: _vm.hasAssets,
                        expression: "hasAssets",
                      },
                    ],
                    staticClass: "arrow",
                    attrs: { size: "xsm", flipped: "", disabled: !_vm.visible },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.nextAsset.apply(null, arguments)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        )
      : _vm.downloading
      ? _c(
          "div",
          {
            staticClass: "controls__finished",
            style: `transform: scale(${_vm.controlsScale})`,
          },
          [
            _c("PickedLabel", { attrs: { notAbsolute: "" } }, [
              _c("h1", {
                domProps: { textContent: _vm._s(_vm.$t("download_title")) },
              }),
            ]),
            _c("PickedLabel", { attrs: { notAbsolute: "" } }, [
              _c("p", {
                domProps: {
                  textContent: _vm._s(_vm.$t("download_description")),
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "controls__downloadButton" },
              [
                _c("RectangleButton", {
                  attrs: {
                    slanted: "",
                    color: "blue",
                    label: _vm.$t("download_cta"),
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.downloadPin.apply(null, arguments)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }